import { useEffect } from 'react';
import { Button, Card } from '@atoms/index';
import { cn } from '@/utils/cn';

export type AlertModalVariant = 'default' | 'danger' | 'warning' | 'success';

export function AlertModal(props: {
  isOpen: boolean;
  title: string;
  message: string;
  variant?: AlertModalVariant;
  confirmText?: string;
  onClose: () => void;
}) {
  const variant = props.variant ?? 'default';
  useEffect(() => {
    if (!props.isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' || e.key === 'Enter') props.onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [props.isOpen, props.onClose]);

  if (!props.isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4">
      <button className="absolute inset-0 bg-black/50" onClick={props.onClose} aria-label="Kapat" />
      <Card className="relative z-[10000] w-full max-w-md p-0 overflow-hidden rounded-2xl shadow-xl">
        <div className="p-6">
          <h3 className="text-xl font-bold text-gray-900 mb-2">{props.title}</h3>
          <p className="text-gray-600 mb-6">{props.message}</p>
          <div className="flex justify-end">
            <Button
              className={cn(
                'min-w-[120px]',
                variant === 'danger' && 'bg-red-600 hover:bg-red-700',
                variant === 'warning' && 'bg-amber-600 hover:bg-amber-700',
                variant === 'success' && 'bg-green-600 hover:bg-green-700'
              )}
              onClick={props.onClose}
            >
              {props.confirmText ?? 'Tamam'}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
